import React from 'react';
import _ from 'lodash';

import BasePage from '../BasePage';
import SectionFirst from '../../../components/Site/Home/SectionFirst';
import Section from '../../../components/Site/Home/Section';
import SectionLast from '../../../components/Site/Home/SectionLast';
import Footer from '../../../components/Site/Footer';

import getRandom from '../../../utils/getRandom';
import { PETS } from '../../../constants';

const petTypeForSection = PETS[_.random(1, PETS.length - 1)];

class Site extends BasePage {
	constructor() {
		super();

		this.state = {
			meet: {
				title: 'Meet your first Tabby.',
				desc: 'Tabby Cat is a browser extension that gives you a new cat with a special name in every new tab.',
				bgColor: 'mauve',
				pet: {
					petType: {
						sku: 'cat_tabbycat',
						type: 'cat',
						name: 'Cat',
					},
					name: getRandom.name(),
					color: 'white',
					body: getRandom.body(),
					head: getRandom.head(),
				},
			},

			pet: {
				title: 'You can pet the cats.',
				desc: 'Some cats love pets and others don’t. See what Professor Burp thinks.',
				bgColor: 'red',
				pet: {
					petType: {
						sku: 'cat_tabbycat',
						type: 'cat',
						name: 'Cat',
					},
					name: {
						full: 'Professor Burp',
					},
					color: 'black',
					body: getRandom.body(),
					head: getRandom.head(),
					likesPets: 'likes',
				},
			},

			goodies: {
				title: 'Collect cool goodies.',
				desc: 'Over time, your Tabby Cats will bring goodies that you can use to dress them up, and more...',
				bgColor: 'teal',
				pet: {
					petType: {
						sku: 'cat_tabbycat',
						type: 'cat',
						name: 'Cat',
					},
					name: getRandom.name(),
					color: 'gray',
					body: 3,
					head: 1,
					likesPets: getRandom.likesPets(),
					hat: 'hat-PartyHat',
					toy: 'toy-Pizza',
				},
			},

			kittens: {
				title: 'Find little kittens.',
				desc: 'Some combinations of goodies lure out special little baby cats. Find them all!',
				bgColor: 'yellow',
				pet: {
					petType: {
						sku: 'cat_tabbycat',
						type: 'cat',
						name: 'Cat',
					},
					name: getRandom.name(),
					color: 'white',
					body: getRandom.body(),
					head: getRandom.head(),
					likesPets: getRandom.likesPets(),
					toy: 'Yarn',
					kitten: 'Frisky',
				},
			},

			pets: {
				title: 'Get new pets!',
				desc: 'Now all furry friends like Dogs, Birds, Turtles, and more are FREE.',
				bgColor: 'purple',
				pet: {
					petType: petTypeForSection,
					...getRandom.petOfTypeForInitialize(petTypeForSection.type),
					name: petTypeForSection.displayName,
					likesPets: 'likes',
				},
			},

			snapshots: {
				title: 'Take snapshots.',
				desc: 'Share your favorite cats and save them forever and ever.',
				bgColor: 'teal',
			},

			work: {
				title: 'Bring cats to work, finally.',
				desc: 'Guaranteed to increase productivity by no percent at all.',
				bgColor: 'light-purple',
				pet: {
					petType: {
						sku: 'cat_tabbycat',
						type: 'cat',
						name: 'Cat',
					},
					name: getRandom.name(),
					color: 'gray',
					body: getRandom.body(),
					head: getRandom.head(),
					likesPets: getRandom.likesPets(),
					toy: 'toy-Coffee',
					glasses: 'glasses-Raybans',
				},
			},
		};
	}

	render() {
		return (
			<div className="page--home">
				<SectionFirst />
				<Section contents={this.state.meet} />
				<Section contents={this.state.pet} />
				<Section contents={this.state.goodies} />
				<Section contents={this.state.kittens} />
				<Section contents={this.state.pets} />
				<Section contents={this.state.snapshots} />
				<Section contents={this.state.work} />
				<SectionLast />
				<Footer bgColor="bg--purple" />
			</div>
		);
	}
}

export default Site;



// WEBPACK FOOTER //
// ./src/routes/Site/Home/index.js